import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DocumentDownloadDisclosureAuditDto,
} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';


@Injectable({
  providedIn: 'root',
})
export class DisclosureAuditRepository {
  constructor(
      private httpClientService: PrmHttpClientService,
  ) {
  }

  auditDocumentDownload(downloadDocumentAuditDto: DocumentDownloadDisclosureAuditDto): Observable<boolean> {
    const endpointUrl = `disclosure-audit/document-download`;
    return this.httpClientService.sendPostRequest(endpointUrl, downloadDocumentAuditDto);
  }
}
